<div
  class="min-h-screen bg-white font-sans selection:bg-teal-100 selection:text-teal-900 dark:bg-gray-900 dark:text-gray-100"
>
  <a
    href="#main-content"
    class="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-[60] px-6 py-3 bg-primary-600 text-white font-bold rounded-lg shadow-xl ring-2 ring-white"
  >
    Skip to main content
  </a>

  <nav class="fixed top-0 left-0 right-0 z-50 py-3 transition-all duration-300 border-b border-white/10"
       [ngClass]="isScrolled
         ? (isLightMode ? 'bg-white/95 backdrop-blur-md shadow-lg border-white/20' : 'bg-gray-900/90 backdrop-blur-md shadow-lg border-gray-800')
         : 'bg-transparent border-transparent'" aria-label="Main Navigation">
    <div class="!max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full mx-auto px-6 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <div
          class="bg-secondary/50 p-2 rounded-xl text-white shadow-lg flex items-center justify-center"
        >
          <div class="w-1.5 h-5 bg-[#1eb052] rounded-full"></div>
          <div
            class="w-1.5 h-6 bg-[#fcd116] rounded-full [animation-delay:0.15s]"
          ></div>
          <div
            class="w-1.5 h-5 bg-black rounded-full [animation-delay:0.3s]"
          ></div>
          <div
            class="w-1.5 h-6 bg-[#00a3e0] rounded-full [animation-delay:0.45s]"
          ></div>
        </div>
        <span
          class="text-2xl font-bold tracking-tight"
          [ngClass]="isScrolled ? 'text-primary' : 'text-white'"
          >GISP</span
        >
      </div>
      <div class="hidden lg:flex items-center space-x-8">
        <a
          *ngFor="let link of links"
          class="font-semibold transition-colors cursor-pointer"
          (click)="scrollTo(link.link)"
          [ngClass]="
            isScrolled
              ? 'text-slate-600 hover:text-teal-600'
              : 'text-white hover:text-teal-200'
          "
          >{{ link.name }}</a
        >
        <!-- Theme Switcher -->
        <label class="switch scale-90 ml-4">
          @if (!isLightMode) {
            <span class="sun"
              ><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="#C99900">
                  <circle cx="12" cy="12" r="5"></circle>
                  <path
                    d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"
                  ></path>
                </g></svg
            ></span>
          }
          @if (isLightMode) {
            <span class="moon"
              ><svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                ></path></svg
            ></span>
          }
          <input
            (ngModelChange)="toggleTheme()"
            [(ngModel)]="isLightMode"
            class="input"
            type="checkbox"
          />
          <span class="slider"></span>
        </label>

        <button [routerLink]="['login']" class="ml-4 flex items-center justify-center gap-2 px-5 py-2 rounded-full text-sm font-bold transition-all transform hover:-translate-y-0.5 border backdrop-blur-sm shadow-lg"
          [ngClass]="isScrolled ? 'bg-primary-600 border-primary-600 text-white' : 'border-white/40 text-white bg-white/10 hover:bg-white/20'">
          <mat-icon class="p-0 m-0 text-[18px]">power_settings_new</mat-icon>
          <span>Login</span>
        </button>
      </div>

      <!-- Mobile Menu Toggle -->
      <div class="-mr-2 flex lg:hidden">
        <button
          (click)="mobileMenuOpen = !mobileMenuOpen"
          class="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 text-slate-900 dark:text-gray-100 hover:bg-white/50 dark:hover:bg-gray-700/50"
          aria-label="Toggle mobile menu"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-controls="mobile-menu"
        >
          <svg
            *ngIf="!mobileMenuOpen"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
          <svg
            *ngIf="mobileMenuOpen"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- Centered Floating Date Badge -->
      <div
        class="absolute top-[calc(100%+16px)] left-1/2 -translate-x-1/2 inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-black/30 backdrop-blur-md border border-white/10 text-teal-50 text-[10px] font-bold shadow-2xl transition-all duration-500"
        [ngClass]="isScrolled ? 'opacity-0 -translate-y-4 pointer-events-none' : 'opacity-100 -translate-x-1/2 translate-y-0'"
      >
        <span class="flex h-1.5 w-1.5 rounded-full bg-teal-400 animate-pulse"></span>
        {{ today }}
      </div>
    </div>

    <!-- Mobile Menu -->
    <div
      id="mobile-menu"
      class="lg:hidden glass-crystal dark:bg-gray-800/90 border-t border-white/50 dark:border-gray-700/50"
      *ngIf="mobileMenuOpen"
    >
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <a
          *ngFor="let link of links"
          (click)="scrollTo(link.link); mobileMenuOpen = false"
          class="block px-3 py-2 rounded-md text-base font-medium text-slate-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-white/50 dark:hover:bg-gray-700/50 cursor-pointer"
          >{{ link.name }}</a
        >
        <a
          [routerLink]="['login']"
          class="block px-3 flex items-center gap-2 py-2 rounded-md text-base font-medium text-white bg-primary-900 hover:bg-primary-800"
        >
          <div class="-mb-1">
            <mat-icon class="p-0 m-0">power_settings_new</mat-icon>
          </div>
          <span>Login</span>
        </a>
      </div>
    </div>
  </nav>

  <main id="main-content">
    <!-- HOME HERO SECTION -->
    <section
      id="home"
      class="tech-bg pt-40 pb-24 px-6 relative overflow-hidden dark:bg-gray-900 min-h-[80vh] flex flex-col justify-center"
    >
      <div
        class="tech-lines absolute inset-0 opacity-50 pointer-events-none"
      ></div>

      <div class="container mx-auto relative z-10">
        <div
          class="max-w-6xl mx-auto text-center lg:text-left grid lg:grid-cols-2 gap-12 items-center"
        >
          <div>

            <div
              class="text-4xl lg:text-6xl font-extrabold text-white leading-tight mb-4"
            >
              Government <br /><span class="opacity-80 text-teal-200"
                >ICT Service Portal</span
              >
            </div>

            <span class="text-teal-50 text-lg opacity-90 leading-relaxed">
              A one-stop window for Government ICT services, projects, and
              technical support provided by the e-Government Authority (e-GA) to
              public institutions.
            </span>

            <div matTooltip="This service is coming soon" class="w-full">
              <div class="bg-white dark:bg-gray-800 p-2 mt-4 shadow-2xl flex flex-col md:flex-row items-center gap-2 opacity-60 cursor-not-allowed">
                <div class="flex-1 flex items-center px-4 gap-3 pointer-events-none">
                  <mat-icon class="text-slate-400">manage_search</mat-icon>
                  <input
                    type="text"
                    disabled
                    placeholder="Search tech solutions..."
                    class="w-full py-3 outline-none text-slate-700 dark:text-gray-200 font-medium bg-transparent"
                  />
                </div>
                <button
                  disabled
                  class="w-full md:w-auto bg-primary text-white px-10 py-3.5 font-bold transition-all pointer-events-none"
                >
                  Find Solution
                </button>
              </div>
            </div>
          </div>

          <div class="hidden lg:flex justify-end relative">
            <div
              class="absolute inset-0 bg-teal-400/20 blur-[100px] rounded-full"
            ></div>
            <div
              class="w-full max-w-sm rounded-[3rem] shadow-2xl border border-dotted border-white/20 rounded-[3rem] shadow-2xl border border-dotted border-white/20"
            >
              <img
                src="assets/images/circle.png"
                class="animate-slow-spin"
                alt="Technology Visualization"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="relative z-20 tech-bg overflow-hidden dark:bg-gray-900">
      <div
        class="h-[50px] w-full py-10 backdrop-blur-md bg-white/10 dark:bg-gray-800/20 border-y border-white/20 flex items-center justify-center relative overflow-hidden"
      >
        <div matTooltip="This service is coming soon" class="relative z-10 cursor-not-allowed">
          <button
            disabled
            class="group relative flex items-center gap-3 px-8 py-3 rounded-full bg-white/10 border border-white/30 backdrop-blur-md transition-all duration-300 opacity-60 pointer-events-none"
          >
            <span class="text-white text-sm sm:text-lg font-bold tracking-wide"
              >Request</span
            >
            <span
              class="text-[#fcd116] text-sm sm:text-lg font-bold tracking-wide flex items-center gap-2"
            >
              Government ICT Service Here
              <mat-icon
                class="transition-transform duration-300 group-hover:translate-x-1"
                >arrow_forward</mat-icon
              >
            </span>
          </button>
        </div>

        <!-- Shine effect -->
        <div
          class="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 translate-x-[-100%] animate-shine"
        ></div>
      </div>
    </div>

    <!-- END HOME HERO SECTION -->

    <!-- SERVICES -->
    <section id="services" class="py-24 bg-white dark:bg-gray-900">
      <div class="!max-w-7xl mx-auto px-6">
        <div class="text-center mb-16">
          <span class="text-primary font-bold uppercase tracking-widest text-sm"
            >Expertise</span
          >
          <div
            class="text-4xl font-black text-slate-900 dark:text-gray-100 mt-2"
          >
            Services Provided
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
          @for (service of services; track service; let i = $index) {
            <div
              class="p-8 rounded-xl bg-slate-50 dark:bg-gray-800 border border-slate-100 dark:border-gray-700 hover:border-teal-200 hover:bg-teal-50/30 dark:hover:bg-gray-700/50 transition-all group"
            >
              <div
                class="w-14 h-14 bg-white dark:bg-gray-700 rounded-2xl flex items-center justify-center text-primary mb-6 shadow-sm group-hover:bg-primary group-hover:text-white transition-all"
              >
                <mat-icon>{{ service.icon }}</mat-icon>
              </div>
              <div
                class="font-bold text-slate-900 dark:text-gray-100 mb-3 text-md"
              >
                {{ service.title }}
              </div>
              <span
                class="text-slate-500 dark:text-gray-400 text-sm leading-relaxed mb-6"
                >{{ service.description }}</span
              >
            </div>
          }
        </div>
      </div>
    </section>
    <!-- END SERVICES -->

    <!-- STATS -->
    <section
      id="stats"
      class="py-16 tech-bg relative overflow-hidden dark:bg-gray-800"
      data-aos="fade-up"
    >
      <div
        class="tech-lines absolute inset-0 opacity-10 pointer-events-none"
      ></div>
      <div class="container mx-auto px-6 relative z-10">
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          @for (stat of stats; track stat) {
            <div class="text-white">
              <div class="text-4xl lg:text-6xl font-black mb-2">
                {{ stat.value }}
              </div>
              <div
                class="text-teal-100 text-sm font-bold uppercase tracking-wider opacity-70"
              >
                {{ stat.label }}
              </div>
            </div>
          }
        </div>
      </div>
    </section>
    <!-- END STATS -->

    <!-- HOW DO I GET STARTED -->
    <section
      id="how-do-i"
      class="py-24 bg-slate-50 dark:bg-gray-900"
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-duration="2000"
    >
      <div class="!max-w-7xl mx-auto px-6">
        <div class="text-center mb-16">
          <span class="text-primary font-bold uppercase tracking-widest text-sm"
            >Service Flows</span
          >
          <div
            class="text-4xl font-black text-slate-900 dark:text-gray-100 mt-2"
          >
            How do I?
          </div>
        </div>

        <div class="grid md:grid-cols-2 gap-2 items-start" role="list">
          @for (item of accordionData; track item.title; let i = $index) {
            <div
              style="--order: {{ i + 1 }}"
              class="glass-crystal move-up dark:bg-gray-800/40 rounded-xl overflow-hidden transition-all duration-300 transform origin-center"
              [ngClass]="{
                'bg-white dark:bg-gray-800 shadow-xl ring-1 ring-primary-500 scale-[1.02] z-10':
                  openIndex === i,
                'hover:bg-white/80 dark:hover:bg-gray-800/80': openIndex !== i,
              }"
              role="listitem"
            >
              <button
                id="accordion-header-{{ i }}"
                (click)="toggleAccordion(i)"
                class="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:bg-slate-50 dark:focus-visible:bg-gray-700/50 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500 select-none group"
                [attr.aria-expanded]="openIndex === i"
                [attr.aria-controls]="'accordion-content-' + i"
              >
                <div class="flex items-center space-x-4">
                  <div
                    class="w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold transition-all duration-300"
                    [ngClass]="
                      openIndex === i
                        ? 'bg-primary text-white shadow-md'
                        : 'bg-slate-100 dark:bg-gray-700 text-slate-500 dark:text-gray-400 border border-slate-200 dark:border-gray-600 group-hover:border-primary-200 dark:group-hover:border-primary-700 group-hover:text-primary-600 dark:group-hover:text-primary-400'
                    "
                    aria-hidden="true"
                  >
                    @if (openIndex !== i) {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                      </svg>
                    }
                    @if (openIndex === i) {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                        ></path>
                      </svg>
                    }
                  </div>

                  <h3
                    class="text-lg font-bold transition-colors"
                    [ngClass]="
                      openIndex === i
                        ? 'text-primary-700 dark:text-primary-400'
                        : 'text-slate-800 dark:text-gray-100'
                    "
                  >
                    {{ item.title }}
                  </h3>
                </div>

                <div
                  class="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300"
                  [ngClass]="{
                    'bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 rotate-180':
                      openIndex === i,
                    'text-slate-400 dark:text-gray-500 group-hover:text-primary-600 dark:group-hover:text-primary-400':
                      openIndex !== i,
                  }"
                  aria-hidden="true"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </button>

              <div
                id="accordion-content-{{ i }}"
                class="accordion-wrapper"
                [ngClass]="{ active: openIndex === i }"
                role="region"
                [attr.aria-labelledby]="'accordion-header-' + i"
              >
                <div class="accordion-inner">
                  <div class="px-6 pb-8 pt-2 pl-[4.5rem]">
                    <div class="space-y-0 relative">
                      @for (
                        step of item.steps;
                        track step;
                        let j = $index;
                        let last = $last
                      ) {
                        <div class="relative pb-6 last:pb-0 group/step">
                          @if (!last) {
                            <div
                              class="absolute left-[11px] top-6 bottom-0 w-0.5 bg-slate-200 group-hover/step:bg-primary-200 transition-colors"
                              aria-hidden="true"
                            ></div>
                          }
                          <div class="flex gap-4">
                            <span
                              class="relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-slate-300 bg-slate-50 text-xs font-medium text-slate-500 group-hover/step:border-primary-400 group-hover/step:text-primary-600 group-hover/step:bg-white transition-colors"
                            >
                              {{ j + 1 }}
                            </span>
                            <p
                              class="text-slate-600 dark:text-gray-300 text-sm leading-6"
                            >
                              {{ step }}
                            </p>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
    <!-- END HOW DO I GET STARTED -->

    <!-- JOIN THE FUTURE -->
    <section class="py-24 px-6" data-aos="fade-up">
      <div
        class="container mx-auto max-w-6xl tech-bg rounded-[3rem] p-12 lg:p-24 relative overflow-hidden shadow-2xl"
      >
        <div
          class="tech-lines absolute inset-0 opacity-10 pointer-events-none"
        ></div>
        <div
          class="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12"
        >
          <div class="text-white text-center lg:text-left">
            <div class="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              Join the <br />Government Portal.
            </div>
            <span class="text-teal-50 opacity-80 text-lg font-medium"
              >Insights on security and services delivered monthly.</span
            >
          </div>
          <div class="w-full max-w-md flex flex-col gap-4">
            <div matTooltip="This service is coming soon" class="w-full">
              <div
                class="flex flex-col gap-4 md:gap-2 md:flex-row bg-white/10 backdrop-blur-md p-2 rounded-2xl border border-white/20 opacity-60 cursor-not-allowed"
              >
                <input
                  type="email"
                  disabled
                  placeholder="Government email address"
                  class="flex-1 bg-transparent px-6 py-6 md:py-0 border md:border-none border-white/20 rounded-xl text-white outline-none placeholder:text-teal-100 pointer-events-none"
                />
                <button
                  disabled
                  class="bg-white text-primary px-8 py-4 rounded-xl font-bold transition-all pointer-events-none"
                >
                  Subscribe
                </button>
              </div>
            </div>
            <p class="text-teal-100/50 text-xs text-center">
              No spam. Only Government Service and infrastructure updates.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!--    END JOIN THE FUTURE-->
  </main>

  <footer
    class="py-12 text-center border-t border-slate-100 dark:border-gray-800 text-slate-400 dark:text-gray-500 text-sm dark:bg-gray-900"
  >
    <div class="flex items-center justify-center gap-2 mb-4 opacity-50">
      <mat-icon>verified_user</mat-icon> <span>ISO 9001: 2015 Certified</span>
    </div>
    © {{ currentYear }} Government ICT Services | GISP Version 3.0.0
  </footer>

  <app-accessibility-menu
    [isOpen]="isAccessibilityMenuOpen"
    (closeMenu)="isAccessibilityMenuOpen = false"
  ></app-accessibility-menu>

  <button
    (click)="isAccessibilityMenuOpen = !isAccessibilityMenuOpen"
    class="fixed bottom-24 right-8 p-3 rounded-full bg-primary-600 text-white shadow-lg hover:bg-primary-500 hover:scale-110 transition-all z-[999] animate-fadeIn focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
    aria-label="Toggle Accessibility Menu"
    [attr.aria-expanded]="isAccessibilityMenuOpen"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6 h-6"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 14c-1.3 0-2.4-.6-3.1-1.4l-.8 1.4c.9.8 2.1 1.4 3.9 1.4 1.8 0 3-.6 3.9-1.4l-.8-1.4c-.7.8-1.8 1.4-3.1 1.4z"
      />
      <circle cx="12" cy="7.5" r="1.5" />
      <path d="M9 11v4h6v-4" />
    </svg>
  </button>

  <button
    *ngIf="showBackToTop"
    (click)="scrollToTop()"
    class="fixed bottom-8 right-8 p-3 rounded-full bg-primary-600 text-white shadow-lg hover:bg-primary-500 hover:scale-110 transition-all z-50 animate-fadeIn focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
    aria-label="Back to top"
  >
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M5 10l7-7m0 0l7 7m-7-7v18"
      ></path>
    </svg>
  </button>
</div>
